export const AxiosRedirect = () => {
    if (process.env.NODE_ENV === "production") {
        return {
            apiURL: process.env.VUE_APP_API_URL,
            clientID: process.env.VUE_APP_CLIENT,
            Authority: process.env.VUE_APP_AUTHORITY_URL,
            clientSecret:'secret',
            grantType:'client_credentials',
            scope:'socket'
        }
    }
    return {
        Authority: 'https://idtest.nilvera.com',
        apiURL: 'https://aktivasyonapitest.nilvera.com',
        clientID: 'activation-socket',
        clientSecret:'secret',
        grantType:'client_credentials',
        scope:'socket'
    }
}


export default {AxiosRedirect}
